export default __webpack_public_path__ + "static/media/Dining-room.a8caa3d7.jpg";